import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Outreach from '../components/Sections/Outreach';
import SideBar from '../components/NavComponents/SideBar';
import DocumentsContainer from '../components/Tables';
import TopNavigation from '../components/NavComponents/TopNavigation';
import User from '../components/SubSections/User';
import Topic from '../components/SubSections/Topic';
import { EditImage } from '../components/SubSections/Topic/imageComponents/editImage';
import UserDashboard from '../components/SubSections/Dashboard';
import AddTopic from '../components/Sections/CreateNewTopic';
import EditCreatedTopic from '../components/Sections/CreateNewTopic/editCreatedTopic';
import Analytics from '../components/Sections/Analytics/analytics';
import EditImagesOrder from '../components/SubSections/Topic/imageComponents/editImagesReorder';
import DeviceIdUserList from '../components/SubSections/User/userListFromDeviceId';
import SettingsScreen from '../components/Sections/SettingsPage';
import { SelectTemplate } from '../components/Sections/Outreach/CreateNewCampaign/selectTempate';
import UninstallReasonUsers from '../components/Tables/TablesList/UninstallsTable/uninstallReasonUsers';
import CampaignList from '../components/Sections/Outreach/CampaignSection/getCampaignList';
import SingleCampaign from '../components/Sections/Outreach/CampaignSection/SingleCampaign/Campaign';
import { SelectTemplateInCampaign } from '../components/Sections/Outreach/CampaignSection/SingleCampaign/selectTempateInCampaign';
import { SendEmailInCampaign } from '../components/Sections/Outreach/CampaignSection/SingleCampaign/sendEmailInCampaign';
import { ContactedUsersList } from '../components/Sections/Outreach/CampaignSection/ListingSections/ContactedUsersList';
import { SentEmailsList } from '../components/Sections/Outreach/CampaignSection/ListingSections/SentEmailsList';
import OutreachAnalytics from '../components/Sections/Outreach/Analytics';
import { PendingEmailsList } from '../components/Sections/Outreach/CampaignSection/ListingSections/pendingEmailsList';
import { ExtensionsMain } from '../components/extensions/extensions-main';
import ExtensionSelectMenu from '../components/extensions/select-menu';
import ExtensionUsers from '../components/extensions/subMenus/extensionUserTable';
import { ExtensionUninstalls } from '../components/extensions/subMenus/extensionUninstalls';
import Scrollbars from 'react-custom-scrollbars-2';
import { EditVideoDetails } from '../components/SubSections/Topic/imageComponents/editVideo';

function MainDashboard() {
	return (
		<div>
			<SideBar />
			<TopNavigation />

			<div className="min-h-screen h-full w-full bg-gray-100 dark:bg-gray-800 text-primary-text-light transition-all duration-500">
				<Routes>
					<Route path="/add-topic" element={<AddTopic />} />

					<Route
						path="/dashboard"
						element={
							<div className="content-container">
								<Scrollbars autoHide>
									<Analytics />
								</Scrollbars>
							</div>
						}
					/>
					<Route path="/documents" element={<DocumentsContainer />} />

					{/* Extension */}
					<Route path="/extensions" element={<ExtensionsMain />} />
					<Route
						path="/extensions/:id/select-menu"
						element={<ExtensionSelectMenu />}
					/>
					<Route path="/extensions/:id/users" element={<ExtensionUsers />} />
					<Route
						path="/extensions/:id/uninstalls"
						element={<ExtensionUninstalls />}
					/>

					<Route path="/extensions/:id/stats" element={<Analytics />} />

					<Route
						path="/uninstall-reason-users/:reason/:extensionId"
						element={<UninstallReasonUsers />}
					/>

					{/* OUTREACH */}
					<Route path="/outreach" element={<Outreach />} />

					<Route path="/outreach/all-campaigns" element={<CampaignList />} />

					<Route
						path="/outreach/all-contacted-users"
						element={<ContactedUsersList />}
					/>

					<Route
						path="/outreach/all-sent-emails"
						element={<SentEmailsList />}
					/>

					<Route
						path="/outreach/all-pending-emails"
						element={<PendingEmailsList />}
					/>

					<Route path="outreach/analytics" element={<OutreachAnalytics />} />

					{/* New campaign */}
					<Route
						path="/outreach/create-campaign"
						element={<SelectTemplate />}
					/>

					{/* Existing campaign */}
					<Route
						path="outreach/campaign/:campaignId"
						element={<SingleCampaign />}
					/>
					<Route
						path="outreach/campaign/:campaignId/select-template"
						element={<SelectTemplateInCampaign />}
					/>
					<Route
						path="outreach/campaign/:campaignId/:selectedTemplates/send-email"
						element={<SendEmailInCampaign />}
					/>
					<Route
						path="/outreach/campaign/:campaignId/contacted-users"
						element={<ContactedUsersList />}
					/>
					<Route
						path="/outreach/campaign/:campaignId/sent-emails"
						element={<SentEmailsList />}
					/>
					<Route
						path="/outreach/campaign/:campaignId/pending-emails"
						element={<PendingEmailsList />}
					/>

					<Route
						path="outreach/campaign/:campaignId/analytics"
						element={<OutreachAnalytics />}
					/>

					{/* Settings */}
					<Route path="/settings" element={<SettingsScreen />} />
					<Route path="/user/:id" element={<User />} />
					<Route
						path="/deviceid-user-list/:deviceId"
						element={<DeviceIdUserList />}
					/>
					<Route
						path="/uninstall-reason-users/:reason"
						element={<UninstallReasonUsers />}
					/>
					<Route path="/topic/:id" element={<Topic />} />
					<Route path="/topic/:id/edit-images" element={<EditCreatedTopic />} />
					<Route path="/dashboard/:id" element={<UserDashboard />} />
					<Route
						path="/topic/:topicId/reorder-images"
						element={<EditImagesOrder />}
					/>
					<Route
						path="/topic/:topicId/image/:imageId"
						element={<EditImage isForPhone={false} />}
					/>
					<Route
						path="/topic/:topicId/phone-image/:imageId"
						element={<EditImage isForPhone={true} />}
					/>
					<Route
						path="/topic/:topicId/video/:videoId"
						element={<EditVideoDetails isForPhone={false} />}
					/>
					<Route
						path="/topic/:topicId/phone-video/:videoId"
						element={<EditVideoDetails isForPhone={true} />}
					/>
				</Routes>
			</div>
		</div>
	);
}

export default MainDashboard;
